import { useTheme } from "../theme/ThemeContext";

/**
 * Brand wordmark. Without an explicit `light`, the variant follows the active theme so the navy
 * wordmark never sits on a dark background; auth heroes pass `light` because they are always dark.
 */
export function Logo({ light, height = 26, className = "" }: { light?: boolean; height?: number; className?: string }) {
  const { resolved } = useTheme();
  const white = light ?? resolved === "dark";
  return (
    <img
      className={`brand-logo ${className}`.trim()}
      src={white ? "/logo-aventuria-white-cropped.png" : "/logo-aventuria-cropped.png"}
      alt="Aventuria"
      style={{ height, width: "auto" }}
    />
  );
}
